import CloseIcon from "@mui/icons-material/Close";
import {
  ForwardMessageContext,
  MessagePanelContext,
  OrganizationContext,
  useTranslation,
} from "hhn-commons";
import { useContext, useState } from "react";
import {
  CloseForwardMessagesPanel,
  CloseForwardMessagesPanelWrapper,
  ForwardMessagesActionPanelWrapper,
  ForwardMessagesIcon,
  ForwardMessagesIconButton,
  TotalMessagesSelectedText,
} from "../../MessagePanel.style";
import ForwardTo from "./ForwardTo";

function ForwardMessagesActionPanel() {
  const { selectedOrgUser } = useContext(OrganizationContext);
  const { isForwardModeOn, turnOffForwardMode } = useContext(
    ForwardMessageContext,
  );
  const { selectedMessages, clearSelectedMessages } =
    useContext(MessagePanelContext);
  const { t } = useTranslation();
  const tNs = (key: any) =>
    t(key, {
      ns: "chat",
      totalMessagesSelected: selectedMessages.length,
    });

  const [isForwardToListModalOpen, setIsForwardToListModalOpen] =
    useState<boolean>(false);

  const handleModalOpen = () => {
    setIsForwardToListModalOpen(true);
  };

  const handleModalClose = () => {
    setIsForwardToListModalOpen(false);
    if (selectedOrgUser) {
      selectedOrgUser.resetRecentContactsData();
    }
  };

  const onCloseForwardMessagesActionPanel = () => {
    clearSelectedMessages();
    turnOffForwardMode();
  };

  return (
    <>
      {isForwardModeOn && (
        <ForwardMessagesActionPanelWrapper data-testid="forward-messages-action-panel">
          <CloseForwardMessagesPanelWrapper>
            <CloseForwardMessagesPanel
              data-testid="close-forward-messages-action-panel"
              aria-label="exit-forward-panel"
              onClick={onCloseForwardMessagesActionPanel}
            >
              <CloseIcon />
            </CloseForwardMessagesPanel>
            <TotalMessagesSelectedText data-testid="total-messages-selected">
              {tNs("forwardTo.messagesSelected")}
            </TotalMessagesSelectedText>
          </CloseForwardMessagesPanelWrapper>
          <ForwardMessagesIconButton
            onClick={handleModalOpen}
            data-testid="forward-messages-btn"
          >
            <ForwardMessagesIcon />
          </ForwardMessagesIconButton>
        </ForwardMessagesActionPanelWrapper>
      )}
      {isForwardModeOn && isForwardToListModalOpen && (
        <ForwardTo
          closeModal={handleModalClose}
          isModalOpen={isForwardToListModalOpen}
          selectedMessagesToForward={selectedMessages.map(m => m.getMessage())}
          closeForwardMessagesActionPanel={onCloseForwardMessagesActionPanel}
        />
      )}
    </>
  );
}

export default ForwardMessagesActionPanel;
